import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Base, LoadDataFacade, SetInitialStateFacade } from '../../../../common/models';
import { AddressPlantGateListInitialState, AddressPlantGateListLoad } from './address-plant-gate-list.actions';
import { AddressPlantGateListState } from './address-plant-gate-list.state';
@Injectable({ providedIn: 'root' })
export class AddressPlantGateListFacade implements LoadDataFacade, SetInitialStateFacade {
  list$: Observable<Base[]> = this.store.select(AddressPlantGateListState.getList);
  loaded$: Observable<boolean> = this.store.select(AddressPlantGateListState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new AddressPlantGateListLoad());
  }

  setInitialState(): void {
    this.store.dispatch(new AddressPlantGateListInitialState());
  }
}
